export default __webpack_public_path__ + "static/media/Ente-auf-Wiese.8cac9a93.png";